module.exports = __webpack_public_path__ + "img/gg.a35023f8.svg";